import { render, staticRenderFns } from "./InfographyFundamental.vue?vue&type=template&id=7c088ba6&"
import script from "./InfographyFundamental.vue?vue&type=script&lang=ts&"
export * from "./InfographyFundamental.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports